import { ExternalMetaDataInterface, MessageContainerInterface, ModifiedSubscriberInterface } from '@nts/std/interfaces';
import { ZoomPropertyViewModel } from './zoom-property-view-model';
import { BigNumber } from '@nts/std/types';

export class ExternalZoomPropertyViewModel extends ZoomPropertyViewModel<{ identity: { [key: string]: string | number | BigNumber; }; description?: string; isValid?: boolean; }> {

  constructor(propertyMetaData: ExternalMetaDataInterface, modifiedSubscriber: ModifiedSubscriberInterface) {
    super(propertyMetaData, modifiedSubscriber);
  }

  override removeError(item: MessageContainerInterface) {
    throw new Error("Method not implemented.");
  }

  setValue(
    propertyValue: {
      identity: { [key: string]: string | number | BigNumber; };
      description?: string;
      isValid?: boolean;
    }
  ) {
    if (propertyValue == null) {
      this.typedValue = null;
    } else {
      this.typedValue = propertyValue;
    }
  }
}
